import React, { useMemo } from 'react';
import cn from 'classnames';
import { useResearchContext } from '@/creditflowresearch/application/Research/ResearchContext';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import DataTable, { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import { DEFAULT_EMPTY_MESSAGE } from '@framework/ui/Molecules/Tables/constants';
import getTableColumns from './columns';

import styles from './researchTable.module.scss';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';

const ResearchTable = () => {
  const {
    researchData: {
      collection,
      sortBy,
      sortOrder,
    },
    sort,
    getDocumentById,
    isFetchingResearchList,
    isFetchingAllGroups,
    isChangingDocumentGroup,
  } = useResearchContext();
  const isFetching = isFetchingResearchList || isFetchingAllGroups || isChangingDocumentGroup;
  const { timeZone } = useUserTimeZoneContext();
  const tableColumns = useMemo(
    () => getTableColumns(getDocumentById, timeZone),
    [getDocumentById, timeZone],
  );

  const handleSortChange = (sortBy, sortOrder) => {
    sort(sortBy, sortOrder);
  };

  return (
    <DataTable
      className={ cn(styles.researchTable, dataTableStyles.isHoverable) }
      dataTest="researchDataTable"
      columns={ tableColumns }
      isFetching={ isFetching }
      loadingComponent={ Spinner }
      data={ collection }
      sortBy={ sortBy }
      sortOrder={ sortOrder }
      onSortChange={ handleSortChange }
      emptyMessage={ isFetching ? '' : DEFAULT_EMPTY_MESSAGE }
      showEmptyStateMessageFirst
    />
  );
};

export default ResearchTable;
